import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const apiService = {
    getAboutUs: () => axios.get(`${API_BASE_URL}/aboutus`),
    getBranches: () => axios.get(`${API_BASE_URL}/branches`),
    getCompanyStats: () => axios.get(`${API_BASE_URL}/companystats`),
    getCustomerOpinions: () => axios.get(`${API_BASE_URL}/customeropinions`),
    getFaqs: () => axios.get(`${API_BASE_URL}/faqs`),
    getHeroSections: () => axios.get(`${API_BASE_URL}/herosections`),
    getPartners: () => axios.get(`${API_BASE_URL}/partners`),
    getServices: () => axios.get(`${API_BASE_URL}/services`),
    getSettings: () => axios.get(`${API_BASE_URL}/settings`),
    getUsers: () => axios.get(`${API_BASE_URL}/users`),
    getShipmentTracking: (code) => axios.get(`${API_BASE_URL}/tracking/${code}`),
    getTermsAndConditions: () => axios.get(`${API_BASE_URL}/termsandconditions`),
    getShipmentAgreement: () => axios.get(`${API_BASE_URL}/shipmentagreement`),
    sendContactUs: (data) => axios.post(`${API_BASE_URL}/contactus`,data),

};

export default apiService;
